import { Box, Paper, Stack, Typography } from '@mui/material'
import NextImage from 'next/image'

import image1 from './section-5-1.webp'
import image2 from './section-5-2.webp'
import image3 from './section-5-3.webp'

export function Section5() {
  return (
    <Stack
      py={8}
      spacing={8}
    >
      <Typography
        component='h2'
        variant='next:h2'
        fontWeight={700}
        textAlign='center'
        flex={1}
      >
        Put Geographic Insights at the Heart of Your Growth Strategy
      </Typography>

      <Stack
        px={4}
        gap={4}
        direction='row'
        justifyContent='center'
        flexWrap='wrap'
      >
        <BenefitCard
          image={image1}
          title='Assess Market Potential'
          alt='Assess Market Potential'
          description='Identify the best regions for expansion based on local demand and demographics. Mapstack unearths market insights so you can invest resources where they matter most.'
        />

        <BenefitCard
          image={image2}
          title='Optimize Logistics & Operations'
          alt='Optimize Logistics & Operations'
          description='Plan distribution routes, pinpoint efficient hubs, and monitor performance across multiple locations. Streamline operations while reducing guesswork.'
        />

        <BenefitCard
          image={image3}
          title='Strategic Forecasting & Expansion'
          alt='Strategic Forecasting & Expansion'
          description='Test multiple ‘what-if’ scenarios for expansion, backed by real data. Discover untapped markets, set realistic goals, and grow without sacrificing quality.'
        />
      </Stack>
    </Stack>
  )
}

function BenefitCard(props) {
  const { title, description, image, alt } = props
  return (
    <Stack
      direction='column'
      component={Paper}
      variant='elevation'
      elevation={8}
      spacing={3}
      sx={{ p: 4, width: '100%', maxWidth: '420px', borderRadius: 3 }}
    >
      <Typography
        component='h3'
        variant='next:h5'
        fontWeight={700}
        textAlign='center'
        flexBasis='60px'
      >
        {title}
      </Typography>
      <Typography
        flex={1}
        color='text.secondary'
        variant='next:h6'
        letterSpacing='tight'
        textAlign='center'
      >
        {description}
      </Typography>

      <Box
        component={Paper}
        variant='outlined'
        sx={{
          position: 'relative',
          aspectRatio: '1/1',
          maxHeight: '400px',
          fontStyle: 'italic',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          borderRadius: 2
        }}
      >
        <NextImage
          src={image}
          fill
          alt={alt}
        />
      </Box>
    </Stack>
  )
}
